import httpService from '@/services/httpService'
import _ from 'lodash'

export const types = {
  ADD_URL_ATTRIBUTES: 'url-attributes/ADD_URL_ATTRIBUTES',
  ADD_BRIEF_URL_ATTRIBUTES: 'url-attributes/ADD_BRIEF_URL_ATTRIBUTES',
  REMOVE_BRIEF_URL_ATTRIBUTES_ATTRIBUTE: 'url-attributes/REMOVE_BRIEF_URL_ATTRIBUTES_ATTRIBUTE',
  ADD_BRIEF_URL_ATTRIBUTES_ATTRIBUTE: 'url-attributes/ADD_BRIEF_URL_ATTRIBUTES_ATTRIBUTE',
  ADD_BRIEF_URL_ATTRIBUTES_ASSOCIATION: 'url-attributes/ADD_BRIEF_URL_ATTRIBUTES_ASSOCIATION'
}

const briefUrlAttributesEmptyData = {
  content_brief_url_attributes: [],
  options: []
}

const briefUrlAttributesAssociationEmptyData = {
  attributeName: '',
  status: false,
  urls: []
}

const emptyData = {
  urlAttributes: [],
  briefUrlAttributes: _.cloneDeep(briefUrlAttributesEmptyData),
  briefUrlAttributesAssociation: _.cloneDeep(briefUrlAttributesAssociationEmptyData)
}
const state = { ...emptyData }

const mutations = {
  [types.ADD_URL_ATTRIBUTES]: function (state, urlAttributes) {
    state.urlAttributes = urlAttributes
  },
  [types.ADD_BRIEF_URL_ATTRIBUTES]: function (state, briefUrlAttributes) {
    state.briefUrlAttributes = briefUrlAttributes
  },
  [types.ADD_BRIEF_URL_ATTRIBUTES_ASSOCIATION]: function (state, briefUrlAttributesAssociation) {
    state.briefUrlAttributesAssociation = briefUrlAttributesAssociation
  },
  [types.REMOVE_BRIEF_URL_ATTRIBUTES_ATTRIBUTE]: function (state, briefUrlAttribute) {
    const index = state.briefUrlAttributes.content_brief_url_attributes.indexOf(briefUrlAttribute)
    state.briefUrlAttributes.content_brief_url_attributes.splice(index, 1)
    const options = _.cloneDeep(state.briefUrlAttributes.options)
    options.find(i => i._id === briefUrlAttribute).associated_urls -= 1
    state.briefUrlAttributes.options = options
  },
  [types.ADD_BRIEF_URL_ATTRIBUTES_ATTRIBUTE]: function (state, briefUrlAttribute) {
    state.briefUrlAttributes.content_brief_url_attributes.push(briefUrlAttribute)
    const options = _.cloneDeep(state.briefUrlAttributes.options)
    options.find(i => i._id === briefUrlAttribute).associated_urls += 1
    state.briefUrlAttributes.options = options
  }
}

const actions = {
  getUrlAttributes: async function ({ commit }, clientId) {
    const response = await httpService.get(`/url_attribute/${clientId}`)
    if (!response) {
      return
    }
    commit(types.ADD_URL_ATTRIBUTES, response.data.url_attributes)
    return response
  },
  updateUrlAttributes: async function (state, { _id, ...params }) {
    const response = await httpService.patch(
      `/url_attribute/change/${_id}`,
      params,
      { successMessage: 'URL Attribute updated successfully' }
    )
    if (!response) {
      return false
    }
    return response.data.is_updated
  },
  removeUrlAttribute: async function (state, { id, ...params }) {
    const response = await httpService.delete(
      `/url_attribute/remove/${id}`,
      { successMessage: 'URL Attribute updated successfully', params }
    )
    if (!response) {
      return false
    }
    return response.data.is_successful
  },
  createNewUrlAttributes: async function (state, params) {
    const response = await httpService.post(
      `/url_attribute/create-new`,
      params,
      { successMessage: 'URL Attribute created successfully' }
    )
    if (!response) {
      return false
    }
    return response.data.is_created
  },
  getBriefURLAttributes: async function ({ commit }, briefId) {
    commit(types.ADD_BRIEF_URL_ATTRIBUTES, _.cloneDeep(briefUrlAttributesEmptyData))
    const response = await httpService.get(`/url_attribute/brief-url-attributes/${briefId}`)
    if (!response) {
      return false
    }
    commit(types.ADD_BRIEF_URL_ATTRIBUTES, response.data)
    return response.data
  },
  createBriefURLAttribute: async function ({ commit }, { briefId, urlAttrId, successMessage = 'URL Attribute added successfully' }) {
    commit(types.ADD_BRIEF_URL_ATTRIBUTES_ATTRIBUTE, urlAttrId)
    const response = await httpService.post(`/url_attribute/brief-url-attributes/${briefId}`, { urlAttrId }, {
      successMessage
    })
    if (!response) {
      commit(types.REMOVE_BRIEF_URL_ATTRIBUTES_ATTRIBUTE, urlAttrId)
      return false
    }
    return response.data
  },
  changeBriefURLAttribute: async function ({ dispatch }, { briefId, data }) {
    const responses = await Promise.all([
      dispatch('removeBriefURLAttribute', {
        briefId,
        urlAttrId: data._id,
        successMessage: ''
      }),
      dispatch('createBriefURLAttribute', {
        briefId,
        urlAttrId: data.value,
        successMessage: 'URL Attribute changed successfully'
      })
    ])
    return responses
  },
  getBriefURLAttributesAssociation: async function ({ commit }, urlAttributeId) {
    commit(types.ADD_BRIEF_URL_ATTRIBUTES_ASSOCIATION, _.cloneDeep(briefUrlAttributesAssociationEmptyData))
    const response = await httpService.get(`/url_attribute/brief-url-attributes-association/${urlAttributeId}`)
    if (!response) {
      return false
    }
    commit(types.ADD_BRIEF_URL_ATTRIBUTES_ASSOCIATION, response.data)
    return response.data
  },
  removeBriefURLAttribute: async function ({ commit }, { briefId, successMessage = 'URL Attribute removed successfully', ...params }) {
    commit(types.REMOVE_BRIEF_URL_ATTRIBUTES_ATTRIBUTE, params.urlAttrId)
    const response = await httpService.delete(
      `/url_attribute/brief-url-attributes/${briefId}`, {
        params,
        successMessage
      })
    if (!response) {
      commit(types.ADD_BRIEF_URL_ATTRIBUTES_ATTRIBUTE, params.urlAttrId)
      return false
    }
    return response.data
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
